interface UseShiftRangeSelectionOptions {
  onRangeSelection?: (from: number, to: number, selected: boolean) => void;
}

export function useShiftRangeSelection(options: UseShiftRangeSelectionOptions) {
  let anchorIndex: number | null = null;

  function onSelectionChange(
    index: number,
    payload: {
      nextSelected: boolean;
      event: MouseEvent | KeyboardEvent;
    },
  ) {
    const { event, nextSelected } = payload;

    if (!event.shiftKey) {
      anchorIndex = index;
      return true;
    }

    const from = anchorIndex ?? index;
    anchorIndex = index;

    if (options.onRangeSelection) {
      options.onRangeSelection(from, index, nextSelected);
      return false;
    }
  }

  function resetSelectionAnchor() {
    anchorIndex = null;
  }

  return {
    onSelectionChange,
    resetSelectionAnchor,
  };
}
